import type { Account } from '@interfaces/account';
import { ApplyForGovFunds } from '@interfaces/account';

import { Icon } from '@ovComponents/1-primative/icon/icon';
import { Card, CardContent } from '@ovComponents/2-component/card/card';

import { GoalLinkingReview } from '@ovComponents/4-module/workflowCompletion/subSteps/account/goalLinking';
import { Box, IconButton, Typography } from 'hephaestus/web';
import { CloseRounded as CloseRoundedIcon } from 'hephaestus/webIcons';
import React from 'react';
import { useTranslation } from 'react-i18next';

type RespAdultReviewItemProps = {
  account: Account;
  onDeleteAccount: (account?: Account) => void;
};
export const RespAdultReviewItem = ({
  account,
  onDeleteAccount,
}: RespAdultReviewItemProps) => {
  const { t } = useTranslation(['workflowCompletions', 'affiliationTypes']);
  return (
    <Card variant='outlined' sx={{ mb: 2 }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pl: 0.9,
          }}
        >
          <Typography variant='bodyLarge' sx={{ fontWeight: 600 }}>
            {t('workflowCompletions:accountReviewPanel.respAdult')}
          </Typography>
          {account.id ? undefined : (
            <IconButton aria-label='close' onClick={() => onDeleteAccount()}>
              <Icon icon={CloseRoundedIcon} size='small' />
            </IconButton>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 2,
            mb: 1,
            px: 1,
          }}
        >
          <Typography variant='labelLarge' sx={{ fontWeight: 600 }}>
            {t(
              'workflowCompletions:accountReviewPanel.basicCanadaEducationSavingsGrant',
            )}
          </Typography>
          <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
            {account.applyForGovFunds?.includes(ApplyForGovFunds.BASIC_CESG)
              ? 'Yes'
              : 'No'}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 1,
            mb: 1,
            px: 1,
          }}
        >
          <Typography variant='labelLarge' sx={{ fontWeight: 600 }}>
            {t('workflowCompletions:accountReviewPanel.canadaLearningBond')}
          </Typography>
          <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
            {account.applyForGovFunds?.includes(ApplyForGovFunds.CLB)
              ? 'Yes'
              : 'No'}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 1,
            px: 1,
          }}
        >
          <GoalLinkingReview account={account} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default RespAdultReviewItem;
